import { useStoreState } from "easy-peasy";
import { Outlet } from "react-router-dom";
import { NotSubscribed } from "./utils/NotSubscribed";

export default function IsServiceAvailable({ serviceType = "" }) {
  const generalSettings = useStoreState((state) => state.generalSettings);

  return generalSettings[serviceType] ? <Outlet /> : <NotSubscribed />;
}
